// Raw colors
const raw = {
  white: 'white',
  red: '#831B21',
  black: '#222',
  darkGrey: '#1D1D1D',
  green: '#1aa51a'
}

// Semantic colors
const { black, white, red, darkGrey, green } = raw
const semanticColors = {
  primary: red,
  error: red,
  backgroundDark: darkGrey,
  backgroundLight: white,
  accentDark: black,
  accentLight: white,
  success: green
}

// Export only semantic colors to discourage using raw colors directly
export default semanticColors
